<template>
  <div>
  </div>
</template>

<script>
import svgAsset from '@/assets/DisplayX1960.svg';
import state from '@/state';

const segments = [
  'hand',
  'relais2',
  'relais1',
  'achtung',
  'symbol3',
  'symbol4',
  'symbol8',
  'symbol12',
  'symbol15',
  'symbol9',
  'symbol16',
  'symbol17',
  'symbol14',
  'symbol22',
  'symbol23',
  'symbol18',
  'symbol2',
  'symbol5',
  'symbol7',
  'symbol10',
  'symbol6',
  'symbol1',
  'symbol11',
  'symbol13',
  'symbol19',
  'symbol20',
  'frost',
  'symbol21',
  'wartung',
  'set',
  'celsius',
  'kelvin',

  'segment1d1',
  'segment1e',
  'segment1f',
  'segment1a1',
  'segment1n',
  'segment1o',
  'segment1g',
  'segment1h',
  'segment1m',
  'segment1l',
  'segment1k',
  'segment1i',
  'segment1d2',
  'segment1c',
  'segment1b',
  'segment1a2',

  'segment2d1',
  'segment2e',
  'segment2f',
  'segment2a1',
  'segment2n',
  'segment2o',
  'segment2g',
  'segment2h',
  'segment2m',
  'segment2l',
  'segment2k',
  'segment2i',
  'segment2d2',
  'segment2c',
  'segment2b',
  'segment2a2',

  'segment3d1',
  'segment3e',
  'segment3f',
  'segment3a1',
  'segment3n',
  'segment3o',
  'segment3g',
  'segment3h',
  'segment3m',
  'segment3l',
  'segment3k',
  'segment3i',
  'segment3d2',
  'segment3c',
  'segment3b',
  'segment3a2',

  'segment4d1',
  'segment4e',
  'segment4f',
  'segment4a1',
  'segment4n',
  'segment4o',
  'segment4g',
  'segment4h',
  'segment4m',
  'segment4l',
  'segment4k',
  'segment4i',
  'segment4d2',
  'segment4c',
  'segment4b',
  'segment4a2',

  'segment5f',
  'segment5g',
  'segment5e',
  'segment5d',
  'segment5a',
  'segment5b',
  'segment5c',
  'sonne',

  'segment6f',
  'segment6g',
  'segment6e',
  'segment6d',
  'segment6a',
  'segment6b',
  'segment6c',
  'dp',

  'segment7f',
  'segment7g',
  'segment7e',
  'segment7d',
  'segment7a',
  'segment7b',
  'segment7c',
  'p6',

  'segment8f',
  'segment8g',
  'segment8e',
  'segment8d',
  'segment8a',
  'segment8b',
  'segment8c',
  'p7',
];

export default {
  props: [
    'bridge',
    'displayBuffer',
  ],

  watch: {
    displayBuffer() {
      // console.log('display', this.displayBuffer);

      const activeClass = 'rs-x1960-active';
      const inactiveClass = 'rs-x1960-inactive';

      for (let i = 0; i < segments.length; i++) {
        const segment = segments [i];
        if (segment) {
          const offset = i >> 3;
          const mask = 1 << (i & 7);
          const state = !!(this.displayBuffer [offset] & mask);
          const elements = this.$el.querySelectorAll(`.rs-x1960-${segment}`);
          if (elements.length === 0) {
            throw new Error(`Unable to find segment ${segment}`);
          }
          for (const element of elements) {
            if (state) {
              if (element.classList.contains(inactiveClass)) {
                element.classList.remove(inactiveClass);
              }
              if (!element.classList.contains(activeClass)) {
                element.classList.add(activeClass);
              }
            } else {
              if (element.classList.contains(activeClass)) {
                element.classList.remove(activeClass);
              }
              if (!element.classList.contains(inactiveClass)) {
                element.classList.add(inactiveClass);
              }
            }
          }
        }
      }
    }
  },

  methods: {
    getDisplaySvg() {
      return this.$el.innerHTML;
    },
  },

  mounted() {
    state.runAsync(async () => {
      const httpResponse = await fetch(svgAsset);
      if (!httpResponse.ok) {
        throw new Error('Unable to fetch display SVG');
      }

      const svgString = await httpResponse.text();

      this.$el.innerHTML = svgString;

      const svgEl = this.$el.querySelector('svg');
      // svgEl.setAttribute('viewBox', '70.7 85.4 71.7 38.6');
      svgEl.setAttribute('width', '100%');
      svgEl.setAttribute('height', '100%');

      // for testing purposes only
      // console.log(segments.length);
      // for (const segment of segments) {
      //   const elems = svgEl.querySelectorAll(`.rs-x1960-${segment}`);
      //   if (elems.length === 0) {
      //     throw new Error(`Unknown segment ${segment}`);
      //   }
      // }
    });
  }
};
</script>

<style>

</style>
